export default __webpack_public_path__ + "static/media/playstore.40bb97af.webp";